import { seatMapState, selectViewId3d } from "@/global/store/data/seatMap";
import { Box, IconButton } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useAppStore } from "@/global/store";

export function IoMedia3dView(props: { url?: string }) {
  const iframeRef = React.useRef<HTMLIFrameElement>(null);
  const dispatch = useDispatch();
  const viewId3dSelected = useAppStore(selectViewId3d);
  const url = props?.url || viewId3dSelected;
  const isViewIdHttps = url?.startsWith("https://");

  const handleClsoe = () => {
    dispatch(seatMapState.actions.set({ viewId3d: "" }));
  };

  return (
    <Box position={"relative"} id="iframe-parent" width="100%" height={"400px"}>
      {url ? (
        <>
          <Box position={"absolute"} top={"8px"} right={"8px"}>
            <IconButton
              onClick={handleClsoe}
              size="small"
              sx={{
                backgroundColor: `rgba(0, 0, 0, 0.4)`,
                color: `rgba(255, 255, 255, 0.7)`,
                "&:hover": { backgroundColor: `rgba(0, 0, 0, 0.6)` },
              }}
            >
              <CloseRoundedIcon />
            </IconButton>
          </Box>
          <iframe
            ref={iframeRef}
            src={isViewIdHttps ? url : `https://${url}`}
            width="100%"
            height={"100%"}
          />
        </>
      ) : null}
    </Box>
  );
}
